import React from "react";

const SeoText = ({ title, desc }) => {
  return (
    <div>
      {title && (
        <h1
          css={`
            margin-top: 50px;
            color: var(--font-color-emp);
            font-size: 24px;
          `}
        >
          {title}
        </h1>
      )}
      {desc && (
        <div
          dangerouslySetInnerHTML={{ __html: desc }}
          css={`
            line-height: 1.47;
            color: var(--font-color-main);
            a {
              color: inherit;
              text-decoration: underline;
            }
          `}
        />
      )}
    </div>
  );
};

export default SeoText;
